/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime : 2019-12-31 11:11:15
 * @LastEditors  : 山淑兰
 */
import Vue from "vue"
import App from "./App.vue"
import router from "./router.js"
import Api from "./api/index"
import Vant from "vant"
import vueSwiper from 'vue-awesome-swiper'
// import Vconsole from 'vconsole'

// const vConsole = new Vconsole()

import {
  Icon,
  Cell,
  CellGroup,
  Popup,
  List,
  Toast,
  ImagePreview,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  DropdownMenu,
  DropdownItem,
  Picker,
  Area,
  DatetimePicker,
  Field,
  Search,
  Collapse, CollapseItem,
  Dialog,
  Uploader,
} from "vant"
import VueI18n from "vue-i18n"
// import Cookies from "js-cookie"

import zh from "./assets/lang/zh.js"
import en from "./assets/lang/en.js"

import "vant/lib/index.css"
import "./lib/rem.js"
import "./sass/reset.css"
import "./lib/essential.js"
import './lib/dist/css/swiper.min.css'
import './lib/dist/js/swiper.min.js'

Vue.config.productionTip = false
Vue.prototype.$http = Api
Vue.use(
  Vant,
  Icon,
  Cell,
  CellGroup,
  Popup,
  List,
  Toast,
  ImagePreview,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  DropdownMenu,
  DropdownItem,
  Picker,
  Area,
  DatetimePicker,
  Field,Search,Collapse, CollapseItem,
  Dialog,
  Uploader,
)

Vue.use(VueI18n)
Vue.use(vueSwiper)
// Vue.use(vConsole)
const i18n = new VueI18n({
  locale: "zh-CN", // 语言标识
  messages: {
    "zh-CN": zh,
    "en-US": en
  }
})


window._VUE = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app")
